import { Row, Col } from "react-bootstrap";

import classes from "./printInventory.module.scss";
import { ReactComponent as PrintIcon } from "@/assets/images/icons/Inventory/printer.svg";

import { formatMiles, formatMilesDecimal } from "@/services/Utils";

const PrintInventoryTagNew = ({ inventories, handlePrint, handlePrintRowSelected }) => {
	return (
		<>
			<Row>
				<Col xs={12} md={12} className={classes.scrollDivTable}>
					<table className={classes.tableSimple}>
						<thead>
							<tr>
								<th>Producto</th>
								<th>Contenido Envase</th>
								<th>Unidad de Medida</th>

								<th>Cód.</th>
								<th>Cantidad</th>
							</tr>
						</thead>
						<tbody>
							{inventories.map((inventory, i) => {
								return (
									<tr key={i}>
										<td>{inventory.tradename}</td>
										<td>{formatMilesDecimal(inventory.container_content)}</td>
										<td>{inventory.unit_measurement}</td>
										<td>{`${inventory.first ? inventory.first : ""} - ${inventory.last ? inventory.last : ""}`}</td>
										<td>{formatMiles(inventory.quantity)}</td>
										<td>
											<div
												style={{
													color: "white",
													background: "#8ac24e",
													borderRadius: "10px",
													marginRight: "5px",
													cursor: "pointer",
												}}
												onClick={() => handlePrintRowSelected(inventory, i)}
											>
												Imprimir
											</div>
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				</Col>
			</Row>
			<Row>
				<Col xs={12} md={12}>
					<div className={`${classes.selecttags} ${classes.active}`} onClick={(_e) => handlePrint("selecttags")}>
						<PrintIcon className={classes.icon} />
						<span className={classes.title}>Imprimir Etiquetas Seleccionadas</span>
					</div>
				</Col>
			</Row>
		</>
	);
};

export default PrintInventoryTagNew;
